import request from '@/utils/request'



/*
 *url  请求路径
 * method  请求类型
 * data  q请求参数
 */
export function ajax(url, method, data = {}) {
  return request({
    url: url,
    method: method,
    params: data
  })
}

// 用户添加价格体系
export function Price(params) {
  return request({
    url: `/ntocc-ctms-api/ctmsPriceStructure/batchAdd`,
    method: 'post',
    data: params
  })
}
